/**
 * @module lib/commercial/keytar/newsletters
 */
import template from "./template";
import Wall from "lib/commercial/keytar/Wall";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import { isNewslettersPage } from "lib/commercial/keytar/helpers";
import isNil from "lodash/isNil";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";

const name = "newslettersWall";
const debugTag = `[KEYTAR] ${name}`;

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed({ customer }) {
    if (isNil(customer)) {
      return false;
    }
    const allowed = {
      isReg: () => customer.canAccessRegisteredContent
    };
    const access = processObjectMethods(allowed);
    logger.info(`${debugTag} access:`, access, allowed);
    return access;
  },
  /** @returns {Boolean} true when wall should be used */
  matcher({ url }) {
    return isNewslettersPage(url);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template
};

export default new Wall("newsletters-page", WALL_TYPES.REGWALL_HARD, props);
